import { Link } from "react-router-dom";
import { Button } from "../../components/ui";
import { CONTACT_EMAIL } from "./MarketingChrome";
import { TariiWord } from "./TariiWord";
import { LayerDiagram } from "./pitch";
import "./landing-top.css";
import "./landing-tail.css";

/**
 * Landing sections 5, 7 and 8 in the pitch form (#2337). Section 5 shows
 * only the three evidence cards the founder ticked, in hours, with the
 * source under each. No dollars and no company figures.
 */

type CostCard = { figure: string; body: string; source: string; note?: string };

export const COST_CARDS: CostCard[] = [
  {
    figure: "12 hours a day, 44 a week",
    body: "A shift worker in Singapore may work up to 12 hours a day and 44 hours a week averaged over 3 weeks, with overtime capped at 72 hours a month.",
    source: "Ministry of Manpower, Singapore, Hours of work, overtime and rest days, 2025",
  },
  {
    figure: "1 day or less",
    body: "9 in 100 US wage and salary workers learn their roster a day (24 hours) or less ahead. 59 in 100 know it 4 weeks or more ahead.",
    source:
      "US Bureau of Labor Statistics, American Time Use Survey, 2024 to 2025 (release USDL-26-1533)",
  },
  {
    figure: "43 hours a year",
    body: "Sickness or injury takes 2.6 percent of working hours, about 43 hours per worker each year, or about 50 minutes a week.",
    source: "UK Office for National Statistics, Sickness absence in the UK labour market: 2022",
    note: "Illustration: a team of 25 loses about 21 hours a week. Team size is our assumption.",
  },
];

export function LandingCosts() {
  return (
    <section
      id="what-it-costs"
      className="pt-landing-section"
      aria-labelledby="what-it-costs-title"
    >
      <h2 id="what-it-costs-title" className="pt-landing-title">
        What it costs
      </h2>
      <p className="pt-lead">What a roster built by hand costs, counted in hours.</p>
      <div className="pt-cost-grid">
        {COST_CARDS.map((c) => (
          <article key={c.figure} className="pt-cost-card">
            <p className="pt-cost-figure">{c.figure}</p>
            <p className="pt-cost-body">{c.body}</p>
            {c.note ? <p className="pt-cost-note">{c.note}</p> : null}
            <p className="pt-cost-source">{c.source}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export function LandingTail() {
  return (
    <>
      <section
        id="beside-systems"
        className="pt-landing-section"
        aria-labelledby="beside-systems-title"
      >
        <h2 id="beside-systems-title" className="pt-landing-title">
          <TariiWord /> beside your systems
        </h2>
        <p className="pt-lead">We exchange files with your system today. An API is planned.</p>
        <LayerDiagram />
      </section>
      <section id="next-step" className="pt-landing-section" aria-labelledby="next-step-title">
        <h2 id="next-step-title" className="pt-landing-title">
          Next step
        </h2>
        <p className="pt-lead">Try the demo on your own, or talk to us about your team.</p>
        <div className="pt-next-actions">
          <Button asChild size="lg">
            <Link to="/demo">Try the demo</Link>
          </Button>
          <Button asChild size="lg" variant="ghost">
            <a href={`mailto:${CONTACT_EMAIL}`}>Talk to us</a>
          </Button>
        </div>
      </section>
    </>
  );
}
